/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { LeaseDetailsDto } from './LeaseDetailsDto';
import type { PosDeliveryDtoNG } from './PosDeliveryDtoNG';
import type { PosFeesDTO } from './PosFeesDTO';
import type { SelectedOfferDto } from './SelectedOfferDto';

export type PosOfferReviewResponseDtoNG = {
    date?: string;
    delivery?: PosDeliveryDtoNG;
    fees?: PosFeesDTO;
    leaseDetails?: LeaseDetailsDto;
    paymentMethod?: PosOfferReviewResponseDtoNG.paymentMethod;
    paymentOption?: PosOfferReviewResponseDtoNG.paymentOption;
    phoneNumber?: string;
    requestId?: string;
    selectedOffers?: Array<SelectedOfferDto>;
};

export namespace PosOfferReviewResponseDtoNG {

    export enum paymentMethod {
        BANK_TRANSFER = 'BANK_TRANSFER',
    }

    export enum paymentOption {
        MONTHLY_FEE = 'MONTHLY_FEE',
        TRANSACTION_FEE = 'TRANSACTION_FEE',
        FULL_PAYMENT = 'FULL_PAYMENT',
    }


}

